import type { ProgressStep } from './ProgressTracker'

// No terminal "Done" step: onboarding ends by navigating straight to /library
// after commit — there is no completion screen (ONBOARDING_UX_SPEC.md: "Done
// screen | Eliminated"). Review is the last tracked step.

// Managed-key users skip the API-key step (it never shows for them).
export const MANAGED_STEPS: ProgressStep[] = [
  { key: 'welcome', label: 'Welcome' },
  { key: 'upload', label: 'Upload' },
  { key: 'profile', label: 'Profile' },
  { key: 'review', label: 'Review' },
]

// BYO users add a one-time Anthropic API-key step before upload.
export const BYO_STEPS: ProgressStep[] = [
  { key: 'welcome', label: 'Welcome' },
  { key: 'api_key', label: 'API key' },
  { key: 'upload', label: 'Upload' },
  { key: 'profile', label: 'Profile' },
  { key: 'review', label: 'Review' },
]

export function stepsForMode(mode: 'managed' | 'byo'): ProgressStep[] {
  return mode === 'byo' ? BYO_STEPS : MANAGED_STEPS
}
